import { render, staticRenderFns } from "./hello-world.vue?vue&type=template&id=600cde9e&scoped=true&shadow"
import script from "./hello-world.vue?vue&type=script&lang=js&shadow"
export * from "./hello-world.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./hello-world.vue?vue&type=style&index=0&id=600cde9e&prod&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "600cde9e",
  null
  ,true
)

export default component.exports